import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Helmet from 'react-helmet'

import { fetch as fetchCellarAction } from 'actions/cellars'
import { fetch as fetchEventAction } from 'actions/events'
import { updateSelectLanguagesAction } from 'actions/languages'

import CellarHeader from 'components/CellarHeader'
import CellarEvents from 'components/CellarEvents'
import CellarLocations from 'components/CellarLocations'
import FBShare from 'components/FBShare'
import TwitterShare from 'components/TwitterShare'
import { croppedImg, coveredImg, getBBURL } from 'utils'

export class Cellar extends React.Component {
  componentDidMount() {
    const { match, currentLanguage } = this.props
    const { cellarId } = match.params

    window.document.getElementsByTagName('body')[0].scrollIntoView(true)
    this.fetchCellarData(currentLanguage)
    window.fbq && window.fbq('track', 'PageView', {
      content_type: 'product_group',
      content_category: 'cellar',
      content_name: cellarId,
      content_ids: [cellarId],
    })
    window.ga && window.ga('send', {
      hitType: 'event',
      eventCategory: 'Reservations',
      eventAction: 'PageView',
      eventLabel: 'Cellar main page',
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      currentLanguage,
      eventsFilters,
    } = this.props

    if (
      currentLanguage !== nextProps.currentLanguage ||
      eventsFilters.guests !== nextProps.eventsFilters.guests
    ) {
      this.fetchCellarData(
        nextProps.currentLanguage,
        nextProps.eventsFilters.guests
      )
    }
  }

  fetchCellarData(currentLanguage, guests) {
    const {
      match,
      fetchCellar,
      fetchEvent,
      updateSelectLanguages,
    } = this.props
    const { cellarId } = match.params

    fetchCellar(cellarId, currentLanguage)
      .then(cellar => {
        cellar.models.map((model) => {
          return fetchEvent(
            model._id,
            currentLanguage,
            guests || model.minGuests || 2,
            true
          )
        })

        updateSelectLanguages(cellar.languages)
      })
  }

  render() {
    const {
      match,
      cellars,
      events,
      locations,
      currentLanguage,
      eventsLanguages,
      locale,
      eventsFilters,
    } = this.props

    const { cellarId } = match.params

    if (!cellars[cellarId] || !cellars[cellarId][currentLanguage]) {
      return null
    }

    const cellar = cellars[cellarId][currentLanguage]

    if (!locations[cellar.mainLocation]) {
      return null
    }

    const mainLocation = locations[cellar.mainLocation][currentLanguage]
    const { giftCards, title } = cellar

    const meta = [
      { name: 'description', content: cellar.description },
      { property: 'og:image', content: croppedImg(mainLocation.mainImage, 1000, 500) },
      { property: 'og:image:width', content: 1000 },
      { property: 'og:image:height', content: 500 },
      { property: 'og:url', content: getBBURL() },
      { property: 'og:title', content: title },
      { property: 'og:description', content: cellar.description },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:site', content: '@wine_around' },
      { name: 'twitter:title', content: title },
      { property: 'twitter:description', content: cellar.description },
      { property: 'twitter:image', content: croppedImg(mainLocation.mainImage, 1000, 500) },
    ]

    return (
      <div className="cellar">
        <Helmet
          title={title}
          meta={meta}
        />
        <div className="space--top-1 cellar__holder">
          <div className="space--bottom-1 cellar__head">
            <div className="wrap">
              <CellarHeader
                cellarTitle={title}
                cellarDescription={cellar.description}
                imageUrl={cellar.logo ? coveredImg(cellar.logo, 600, 600, 'png') : ''}
                cellarUrl={cellar.website}
              />
              <FBShare url={window.location.href} title={title} />
              <TwitterShare url={window.location.href} title={title} />
            </div>
          </div>
          <hr id="cellar__hr" />
          <div>
            <CellarEvents
              cellar={cellar}
              cellarId={cellarId}
              events={events}
              locations={locations}
              eventsCurrentLanguage={currentLanguage}
              eventsLanguages={eventsLanguages}
              locale={locale}
              giftCards={giftCards}
              eventsFilters={eventsFilters}
            />
            <CellarLocations
              cellarId={cellarId}
              locations={locations}
              eventsCurrentLanguage={currentLanguage}
            />
          </div>
        </div>
      </div>
    )
  }
}

Cellar.propTypes = {
  cellars: PropTypes.object.isRequired,
  events: PropTypes.object.isRequired,
  locations: PropTypes.object.isRequired,
  eventsLanguages: PropTypes.array.isRequired,
  currentLanguage: PropTypes.string.isRequired,
  fetchCellar: PropTypes.func.isRequired,
  fetchEvent: PropTypes.func.isRequired,
  updateSelectLanguages: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  eventsFilters: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    cellars: state.cellars,
    events: state.events,
    locations: state.locations,
    eventsLanguages: state.languages.cellarLanguages,
    currentLanguage: state.languages.cellarLanguage,
    locale: state.ui.locale,
    eventsFilters: state.eventsFilters,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchCellar: fetchCellarAction,
    fetchEvent: fetchEventAction,
    updateSelectLanguages: updateSelectLanguagesAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Cellar)
